import { createContext } from "react";

const flowContext = createContext([{}, () => {}]);

export default flowContext;
